export const itaTexts = {
	knowMore: 'Per saperne di più',
	ngoPurpose:
		"To raise funds for the NGO's projects, keep you up	to date on the NGO and the progress of the project you donated to and issue tax	deduction certificates.",
	termsPurpose:
		'Manage the business relationship in all its fields, as well as its donation and certificate application, and the sending of commercial communications electronically.',
	termsRights:
		'You have	the right to access, correct and delete your data, as well as other rights, as explained	in the additional information.',
	termsAdditionalInfo:
		'You can consult additional and detailed Data Protection information on our <a href="https://www.worldcoo.com/gdpr">website</a> or by <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	unexpectedError: 'Si è verificato un errore imprevisto',
	amountError: 'La somma di denaro non era valida',
	authError: 'Si è verificato un errore durante l`autorizzazione del pagamento',
	cardError: 'Si è verificato un errore con la tua carta',
	referralError: 'Si è verificato un errore di riferimento',
	transactionError: 'Si è verificato un errore con la transazione',
	resetFilters: 'Resetta filtri',
	category: 'Causa',
	basicNeeds: 'Bisogni primari',
	humanRights: 'Diritti umani',
	education: 'Istruzione',
	emergency: 'Emergenza',
	feeding: 'Alimentazione',
	environment: 'Ambiente',
	habitat: 'Ambiente',
	health: 'Salute',
	clear: 'Pulisci',
	active: 'Attivo',
	finished: 'Finito',
	status: 'Stato',
	filters: 'Filtri',
	year: 'Anno',
	dedicateToTemplate:
		'Hello! You receive this email because {{donorName}} has given you a donation of {{amount}} {{currency}} for the NGO {{ngoName}} in the campaign {{campaignName}}. This donation has been dedicated to you with the intention of making the world a little better place',
	dedicateToTemplateTitle: 'Il tuo messaggio di dedizione',
	dedicateToWarning:
		"Questo messaggio verrà inviato al Destinatario all'indirizzo e-mail fornito sopra. Confermo di aver chiesto al destinatario il permesso di inviare questo messaggio",
	dedicateToRecipientEmail: 'Email del destinatario.',
	dedicateToRecipientName: 'Nome del destinatario.',
	dedicateDonationTitle: 'Dedicare una donazione.',
	dedicateDonationMessage: 'Vorrei dedicare la mia donazione a qualcuno',
	responsable: 'Controller',
	purpose: 'Finalità',
	legitimation: 'Legittimazione',
	recipients: 'Destinatari',
	rights: 'Diritti',
	ngoAdditionalInfoTitle: 'Posizione ed informazione addizionale',
	termsButton: 'Ho letto, accetto e capisco',
	id: 'ID Number',
	taxId: 'Tax ID Number',
	passport: 'Passport',
	others: 'Others',
	campaignAudited: 'Campagna controllata da',
	termsAndCons: 'termini di Worldcoo Data Protection',
	ngoTerms: 'termini di Worldcoo Data Protection',
	haveReadAndAccept: 'Li ho letti, capiti e li accetto',
	aCampaignBy: 'Una campagnia di',
	acceptNgoTermsLink: 'termini di Protezione di {{ngo}}',
	acceptRecurrentTermsLink:
		'Ho letto, comprendo ed accetto i <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">termini di Protezione dei Dati delle ONGs</a>',
	activities: 'Attività',
	additionalInfo: 'Informazioni addizionali',
	anyComments: 'Vuoi lasciare qualche commento?',
	businessName: 'Ragione Sociale',
	campaignObjectives: 'Obiettivi della campagna',
	campaignFunded: 'Campagna finanziata!',
	campaigns: 'Campagna',
	cancel: 'Cancellare',
	cardBrandNotAccepted: 'Non si accetta questo tipo di carta.',
	cardRegisteredSuccessfully: 'La carta è stata registrata',
	cardsSupported: 'Carte accettate:',
	certificateOnlyValidInExpeditionCountry:
		'Il certificato di Donazione avrà validità solo nel Paese di origine ove è iscritta l’entità beneficiaria delle donazioni.',
	certificateNeededData: 'Dati necessari per ottenere il certificato di donazione:',
	change: 'Cambiare',
	checkoutSuccess: 'La tua donazione è stata correttamente registrata, grazie per aver partecipato.',
	city: 'Città',
	collectedFundsDistribution: 'I fondi raccolti saranno ripartiti equamente tra i seguenti progetti:',
	comments: 'Commenti',
	company: 'Azienda',
	confirm: 'Confermare',
	contactData: 'Dati di contatto',
	cookiesMessage: 'Questo sito utilizza cookies. Se prosegui la navigazione consideriamo che ne accetti l’utilizzo.',
	country: 'Paese',
	creditCard: 'Carta di credito',
	dataReceivedSuccessfully: 'Abbiamo ricevuto correttamente i tuoi dati.',
	description: 'Descrizione',
	directBeneficiaries: 'Beneficiari diretti',
	directBeneficiariesDescription:
		'Quelle Persone che di forma naturale hanno ricevuto benefici dalle azioni sviluppate dalla campagna',
	documentNumber: 'Nº di documento',
	documentType: 'Tipo di documento',
	donationAmount: 'Importo della donazione',
	donationAmountError: 'L’importo della donazione non è corretto',
	donationAmountMinimumIs: 'Limporto mínimo è di  {{amount}}',
	donationCertificate: 'Certificato di donazione',
	donations: 'Donazioni',
	donors: 'Donatori',
	donated: 'Donati',
	donatedOf: 'Donato da',
	donateMonthly: 'Donare mensilmente',
	donationOnBehalf: 'Fare donazioni per conto di ',
	door: 'Porta',
	email: 'Posta elettronica',
	fillFollowingFields: 'Compila i seguenti campi',
	finish: 'Concludere',
	floor: 'Appartamento',
	funded: 'Finanziato',
	genericCardError: 'C’è stato qualche errore con la tua carta.',
	goBack: 'Tornare',
	identityDocument: 'Documento di identità',
	indicateDataToIdentify: 'Segnalaci questi dati affinché possiamo identificarti:',
	indirectBeneficiaries: 'Beneficiari indiretti',
	indirectBeneficiariesDescription:
		'Tutte quelle persone identificabili, che ricevono un effetto potenziale dalle azioni sviluppate dalla campagna.',
	inDoubtContactHere: 'Qualsiasi dubbio puoi contattarci qui:',
	informYouViaMail: 'Ti informeremo dettagliatamente tramite posta elettronica.',
	makeDonation: 'Fare donazioni',
	makeOneTimeDonation: 'Fare donazioni puntuali',
	makeYourDonation: 'Fai la tua donazione',
	manageMyDonations: 'Gestisci la mia donazione',
	manyThanks: 'Grazie mille!',
	modifyAmount: 'Modifica l’importo della donazione ',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Abbiamo ricevuto correttamente la tua richiesta.</p><p>Tra qualche giorno ti manderemo una mail confermandoti che abbiamo realizzato i cambi richiesti.</p><p>Se hai qualche dubbio puoi contattarci qui :</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Se gia sei un donatore, qui puoi modificare o cancellare la tua donazione:',
	moreInfo: 'Ulteriori Informazioni',
	name: 'Nome',
	next: 'Seguente',
	otherAmount: 'Altro Importo',
	overlayError:
		'<p>Si è verificato un errore </p><p>Per favore, riprova piu’ tardi o contattaci quí:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Particolare',
	paymentData: 'Dati di pagamento',
	paymentType: 'Forma di pagamento',
	personalData: 'Dati personali',
	pleaseFillFields: 'Per favore, compila i seguenti campi:',
	postalCode: 'Códice postale',
	province: 'Provincia',
	raised: 'Raccolti',
	raisedTillNow: 'Raccolti fino al momento:',
	recurrentFormError:
		'Si è verificato un errore elaborando la tua richiesta. Per favore riprova piu tardi o contattaci:',
	region: 'Regione',
	repeatEmail: 'Introdurre nuovamente l’indirizzo Email',
	repsolEmployeesPortal: 'Portale solidale dei dipendenti',
	seeCampaigns: 'Vedere campagna',
	send: 'Inviare',
	share: 'Condividere',
	sorry: 'Ci dispiace!',
	stairNumber: 'Scala',
	stopMakingDonation: 'Cancella la donazione mensile',
	step1: 'Passo 1',
	step2: 'Passo 2',
	step3: 'Passo 3',
	step4: 'Passo 4',
	streetName: 'Nome della via',
	streetNumber: 'Num.',
	streetType: 'Tipo di vía',
	summary: 'Riassunto',
	surname: 'Cognome',
	telefonicaUseCorporateMail:
		'* Se sei un dipendente di Telefónica utilizza preferibilmente il tuo indirizzo di posta elettronica aziendale .',
	thanks: 'Grazie!',
	typeTheAmount: 'Digita l’importo',
	unavailableLanguageMessage:
		'Non disponiamo del contenuto di questa campagna in spagnolo. Lavoriamo costantemente per offrirti maggior contenuti nella tua lingua. Grazie per la tua pazienza.',
	updatesAndLinks: 'Attualizzazione e link',
	validationEqualFields: 'I campi {{label}} y {{fieldName}} non sono uguali',
	validationIsRequired: 'Il campo {{label}} è obbligatorio',
	validationValidEmail: 'Il campo {{label}} non è un email valido',
	viewCampaignInfo: 'Vedere informazioni della campagna',
	viewInfo: 'Vedere informazioni',
	wantCertificate: 'Voglio il certificato di donazione',
	wantWorldcooNewsletter: 'Vorrei ricevere informazioni circa Worldcoo',
	whatIsNewAmount: 'Dicci quale è il nuovo importo che vuoi donare {{currency}}):',
	whatYouWantToDo: 'Che vuoi fare?',
	whoWillBenefit: 'Chi sarà il beneficiario?',
	youCanAlsoDonateOneTime: 'Puoi anche effettuare una donazione puntuale accedendo a qualsiasi di questi',
	yourDonationWillBeCharged: 'La tua donazione sarà resa effettiva il 15 di ogni mese.',
	yourRequestIsProcessing: 'La tua richiesta si sta lavorando. Attendi qualche secondo per favore',
	youSureCancelRecurrentDonation: 'Confermi che vuoi cancellare la donazione mensile?',
	ngoTermsTitle: 'Informazioni basiche sulla Protezione dei dati',
	ngoLegitimation: 'The legal basis for handling your data is your consent.',
	ngoRecipients: 'No data shall be transferred to third parties.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl:
		'È possibile consultare informazioni aggiuntive e dettagliate sulla protezione dei dati sul nostro sito Web: ',
	amountMustBeGreaterThanZero: "L'importo deve essere maggiore di 0",
	amountMustBeLowerThan3000: "L'importo deve essere inferiore a 3000",
	metafieldsNoTicket: 'Riga 0. Donazione senza voce',
	metafieldsTickets:
		'Di quanti inviti hai bisogno per il concerto? Tieni presente che per ogni 10€ donati riceverai un invito.',
};
